import { DEFAULT_PAGES_SECURITY, validateRole } from '@backoffice/types/security';
const middleware = async ({ $auth, $config, app, route, params, query, localePath, redirectLocale, getRouteBaseName, error, }) => {
    var _a, _b, _c, _d, _e, _f;
    const routeName = getRouteBaseName(route);
    if (!routeName || routeName === 'login')
        return;
    const isCountingMode = ((_a = $config.insurerConfig.backoffice) === null || _a === void 0 ? void 0 : _a.mode) === 'countings';
    const isCountingRoute = routeName.split('-')[0] === 'chiffrage';
    if (isCountingMode && !isCountingRoute) {
        return redirectLocale({ name: 'chiffrage' });
    }
    if (!isCountingMode && isCountingRoute) {
        return redirectLocale({ name: 'index' });
    }
    const security = [
        (_e = (_d = (_c = (_b = $config.insurerConfig.backoffice) === null || _b === void 0 ? void 0 : _b.security) === null || _c === void 0 ? void 0 : _c.pages) === null || _d === void 0 ? void 0 : _d[routeName]) !== null && _e !== void 0 ? _e : DEFAULT_PAGES_SECURITY[routeName],
    ].flat();
    if (!security.length)
        return;
    if (route.query.resetAuth) {
        $auth.reset();
    }
    if (!$auth.loggedIn)
        return redirectLocale({ name: 'login' });
    await $auth.fetchUserOnce();
    const roles = $auth.user.roles;
    if (!security.some((role) => validateRole(roles, role))) {
        let path;
        if (route.redirectedFrom)
            path = route.redirectedFrom;
        else {
            const parent = route.matched[route.matched.length - 1].parent;
            const parentRoute = parent && ((_f = app.router) === null || _f === void 0 ? void 0 : _f.resolve(parent));
            if (parentRoute) {
                path = localePath({
                    name: getRouteBaseName(parentRoute.route),
                    params,
                    query,
                });
            }
            else
                path = localePath({ name: 'index' });
        }
        error({
            message: "Vous n'avez pas accès à cette page",
            statusCode: 403,
            path,
        });
    }
};
export default middleware;
